import React from "react";
import { Box, Typography } from "@mui/material";

const BRANDS = [
  "Essae",
  "WEP",
  "Trucount",
  "NGX",
  "Balaji",
  "Pixel",
  "Unisys",
  "Casio",
];

/** Muted strip of partner-brand badges; horizontally scrollable on mobile. */
const BrandStrip: React.FC = () => (
  <Box sx={{ textAlign: "center" }}>
    <Typography
      variant="overline"
      component="p"
      sx={{ color: "text.secondary", mb: 2 }}
    >
      Authorized dealer for leading brands
    </Typography>
    <Box
      sx={{
        display: "flex",
        gap: { xs: 1.5, md: 2.5 },
        justifyContent: { xs: "flex-start", md: "center" },
        overflowX: "auto",
        pb: 1,
        px: { xs: 1, md: 0 },
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {BRANDS.map((brand) => (
        <Box
          key={brand}
          sx={{
            flexShrink: 0,
            px: 3,
            py: 1.2,
            borderRadius: "999px",
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.paper",
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: 700, color: "text.secondary", letterSpacing: "0.04em" }}
          >
            {brand}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

export default BrandStrip;
